import { render, staticRenderFns } from "./read.vue?vue&type=template&id=c1d9fac6&scoped=true&"
import script from "./read.vue?vue&type=script&lang=ts&"
export * from "./read.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d9fac6",
  null
  
)

export default component.exports